import { z } from "zod";
import translate from "src/lib/translate";

/**
 * Zod produces its default issue messages in English (e.g. "Required") and
 * AutoForm renders `issue.message` verbatim, so those defaults leak into the
 * UI untranslated for Spanish users (FEWEB-2535). This error map resolves the
 * message through i18next at parse time, so validation errors always match
 * the active language.
 *
 * AutoForm strips empty strings before parsing, which makes an empty required
 * field surface as `invalid_type` with `received: "undefined"` — that is the
 * "Required" case seen in the onboarding task pop-ups.
 */
const translatedZodErrorMap: z.ZodErrorMap = (issue, ctx) => {
  const isMissingRequiredValue =
    issue.code === z.ZodIssueCode.invalid_type &&
    issue.received === z.ZodParsedType.undefined;

  if (isMissingRequiredValue) {
    return { message: translate("required") };
  }

  return { message: ctx.defaultError };
};

export default function registerTranslatedZodErrorMap(): void {
  z.setErrorMap(translatedZodErrorMap);
}
